import addError from '../../../utils/error.jsx';

export function request(id, accountId, comment) {
    return {
        type: 'BETS_COMMENT_BET_REQUEST',
        accountId,
        comment,
        id
    };
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'BETS_COMMENT_BET_ERROR',
        errors,
        id
    };
}

export function finish(id, data) {
    return {
        type: 'BETS_COMMENT_BET_FINISH',
        data,
        id
    };
}
